import { FC } from 'react';
import { format } from 'date-fns';
import { CalendarTodayOutlined } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';

import { DateInputFormat } from '@shared/helpers/date';
import ImagePreview from '@modules/Tributes/components/ImagePreview';


interface Props {
    timelineEvent: Tributes.TimelineEvent;
    onViewMedia?: (selectedFileIndex: number) => void;
}

export const TimelineEventPreview: FC<Props> = (props) => {
  const { timelineEvent, onViewMedia } = props;

  return (
    <Card>
      {timelineEvent?.date && (
        <CardHeader subheader={(<>
          <Stack component={Typography} spacing={1} direction="row" fontSize="0.85rem" alignItems="center">
            <CalendarTodayOutlined fontSize="inherit" />
            <span>{format(timelineEvent.date, DateInputFormat)}</span>
          </Stack>
        </>)} />
      )}
      {timelineEvent.media?.[0] && (
        <CardMedia
          component={ImagePreview}
          readonly
          file={timelineEvent.media[0]}
          slotProps={{
            paper: {
              sx: {
                width: '100%',
                height: { xs: '320px', sm: '490px' },
                margin: 0,
              },
            },
          }}
          onView={() => onViewMedia?.(0)}
        />
      )}
      {timelineEvent.text && (
        <CardContent>
          <Typography variant="body2" color="textSecondary">
            {timelineEvent.text}
          </Typography>
        </CardContent>
      )}
    </Card>
  );
};
